/* eslint-disable max-len */
import React from 'react'
import ThreeDotsLoader from '../LoadingDots'

const PrefrencesModal = ({setPrefrencesModal,prefrencesModal,notificationPrefrences,setNotificationprefrences, handleSetNotificationPreferences, setNotificationError, notificationError,setThreeDotsLoader,threeDotLoader}) => {
    return (
        <div className={`modal fade fixed ${prefrencesModal ? 'show' : 'hidden'} top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto notificationPreference`} id="notificationPreference" tabIndex="-1" aria-labelledby="notificationPreference" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative sm:max-w-[486px] sm:min-w-[486px] min-w-full px-3 mx-auto pointer-events-none" style={{margin: 'auto'}}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current sm:px-5 px-3 sm:pt-[32px] pt-4 pb-5">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between rounded-t-md relative sm:px-2">
                        <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406] text-center w-full pl-3.5" id="exampleModalScrollableLabel">
                            Notification Preferences
                        </h5>
                        <button onClick={() => setPrefrencesModal(false)} type="button" data-bs-dismiss="modal" aria-label="Close">
                            <img src="images/Icon-ionic-ios-close.svg" alt="icon" className="w-[14px] h-[14px]"/>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p className="sm:text-lg text-base font-normal text-[#000000] pt-2 text-center">Receive order related updates via</p>
                        <div className="mt-5 border border-[#D3D3D3] p-3.5 flex justify-between items-center rounded-lg bg-[#F5F5FA]">
                            <p className="text-lg font-semibold text-[#000000]">Email</p>
                            <div className="status custom-toggle1 flex items-start">
                                <label className="switch">
                                    <input 
                                        checked={notificationPrefrences.email}
                                        onChange={() => 
                                        {setNotificationprefrences((prevState) => ({
                                            ...prevState,
                                            email: !notificationPrefrences.email,
                                        })); setNotificationError(false)}
                                        }
                                        type="checkbox"/><span className="slider round"></span>
                                </label>
                                <span
                                    className="text-xs2 font-normal text-[#090406]"
                                    style={{marginLeft: '1px'}}>
                                </span>
                            </div>
                        </div>
                        <div className="mt-4 border border-[#D3D3D3] p-3.5 flex justify-between items-center rounded-lg bg-[#F5F5FA]">
                            <p className="text-lg font-semibold text-[#000000]">SMS</p>
                            <div className="status custom-toggle1 flex items-start">
                                <label className="switch">
                                    <input 
                                        checked={notificationPrefrences.sms}
                                        onChange={() => 
                                        {setNotificationprefrences((prevState) => ({
                                            ...prevState,
                                            sms: !notificationPrefrences.sms,
                                        })); setNotificationError(false)}
                                        }
                                        type="checkbox"/><span className="slider round"></span>
                                </label>
                                <span
                                    className="text-xs2 font-normal text-[#090406]"
                                    style={{marginLeft: '1px'}}>
                                </span>
                            </div>
                        </div>
                        <div className="mt-4 border border-[#D3D3D3] p-3.5 flex justify-between items-center rounded-lg bg-[#F5F5FA]">
                            <p className="text-lg font-semibold text-[#000000]">WhatsApp</p>
                            <div className="status custom-toggle1 flex items-start">
                                <label className="switch">
                                    <input 
                                        checked={notificationPrefrences.whatsapp}
                                        onChange={() => 
                                        {setNotificationprefrences((prevState) => ({
                                            ...prevState,
                                            whatsapp: !notificationPrefrences.whatsapp,
                                        }));setNotificationError(false)}
                                        }
                                        type="checkbox"/><span className="slider round"></span>
                                </label>
                                <span
                                    className="text-xs2 font-normal text-[#090406]"
                                    style={{marginLeft: '1px'}}>
                                </span>
                            </div>
                        </div>
                        {notificationError && <p>Please select any one of the preferences in Email or SMS</p>}
                        <div className="mx-auto mt-5 flex justify-center">
                            <button 
                                type="button" 
                                className="w-[310px] rounded-[16px] bg-[#555259] sm:py-[18px] py-3 px-2 text-lg font-semibold text-[#FFFFFF] save-notiPreference" 
                                data-bs-dismiss="modal" 
                                aria-label="Close"
                                onClick={() => handleSetNotificationPreferences()}
                            >
                                {threeDotLoader ? <div className='ml-[131px]'><ThreeDotsLoader /></div> : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrefrencesModal
